module.exports = __webpack_public_path__ + "static/media/FTM.07a62e98.png";